// CostBadge — small TopBar pill showing today's accumulated spend.
//
// Stays present so the user always sees what they've burned today.
// Hover / tap for a richer breakdown (per-model split could come later).

import { formatUsd, useCost } from '../state/cost';

export function CostBadge() {
  const todayUsd = useCost((s) => s.todayTotalUsd);
  const todayGens = useCost((s) => s.todayGenerations);
  const todayTokens = useCost((s) => s.todayTokens);
  const sessionUsd = useCost((s) => s.sessionTotalUsd);

  const isZero = todayUsd === 0;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[10.5px] tabular-nums ${
        isZero
          ? 'border-neutral-800 bg-neutral-900 text-neutral-500'
          : 'border-emerald-900/60 bg-emerald-950/30 text-emerald-200'
      }`}
      title={
        `今日: ${formatUsd(todayUsd)} · ${todayGens} generations · ${todayTokens.toLocaleString()} tokens\n` +
        `本次 session: ${formatUsd(sessionUsd)}`
      }
    >
      <span aria-hidden className="inline-block h-1.5 w-1.5 rounded-full bg-current opacity-60" />
      今日 {formatUsd(todayUsd)}
    </span>
  );
}
